import newUser from '@/router/middlewares/newUser.js';
import OnboardIndexView from '@/pages/onboard/index.vue';
import aboutYouView from '@/pages/onboard/aboutYou.vue';
import SocialConnectView from '@/pages/onboard/socialConnect.vue';
import InviteTeamMembersView from '@/pages/onboard/inviteTeamMembers.vue';
import CreateProjectView from '@/pages/onboard/createProject.vue';

export default [
  {
    path: '/onboard',
    name: 'Onboard',
    component: OnboardIndexView,
    meta: {
      layout: 'GuestLayout',
      middleware: [newUser]
    },
    children: [
      {
        path: '/onboard',
        name: 'aboutMe',
        component: aboutYouView
      },
      {
        path: 'social-connect',
        name: 'socialConnect',
        component: SocialConnectView
      },
      {
        path: 'invite-team',
        name: 'inviteTeamMembers',
        component: InviteTeamMembersView
      },
      {
        path: 'create-project',
        name: 'newProject',
        component: CreateProjectView
      }
    ]
  }
];
